import React, { useState, useEffect,useContext } from "react";
import {SesionContext} from '../../../context/SesionContext';
//import SidebarEvents from "./SideBar"
import SidebarEvents from "../Sidebar"
import Menu from "../Menu"
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { getAccionOption } from "../../../helpers/MenuActions";
import { Row, Col } from 'react-bootstrap';

import "../../../dhtmlx/codebase/suite.css";
const Wrapper = styled(Row)`
  margin: 0;
  padding:0;
`;

const Body = styled(Row)`
  margin: 0;
  padding:0;
  background-color: #F0F0F0;
  width: 100%;
`;

 const ContentContainer = styled(Col)`
 display: flex;
 padding: 8px 16px;
 overflow: auto;

`;
function Dashboard({ authorized }){
  const {cerrarSesion} = useContext(SesionContext);

  /**
   * Usando el menu en dhtmlx nos regresa la informacion de 
   * elemento se le hizo click. para poder mostrar el contenido 
   * usaremos dos estados
   * 
   * 'option' es el estado que escuchara al menu, queremos que lo primero que muestre sea el dashboard
   * 'content' escucha si cambia option para rendereizar el contenido
   * 
   * Para renderizar el contenido usamos renderContent de MenuActions
   *
   */
  const [option, setOption] = useState('Ventas');
  const [content, setContent] = useState(getAccionOption('Ventas').content);
  const [collapsed, setCollapsed] = useState(true);

  function toogleOptionSidebar(id){
    if(option === id){
      console.log(id)
      //si es el mismo entonces recargamos;
      setContent(<></>);//borramos contenido
      setTimeout(()=>{
        setContent(getAccionOption(id).content);//cargamos el seleccionado
      },100)
    }
    setOption(id);
  };
  /**
   * Escuchamos cada que cambie option, llamaremos al renderizado
   * si la funcion regresa algo cambiamos el contenido
   */
  useEffect(() => {
    let accion = getAccionOption(option);
    if(accion.content){
      //se cambia el content
      setContent(accion.content);
    }
    else{
      //accion sin cambiar el content
      if(accion.accion==='logout'){
        cerrarSesion();    
      }
    }
  }, [option]);
 

  if(!authorized){
    return <Redirect to = "/"/>;
  }

  return (
    
    <Wrapper id="wrapper-container">
      <Menu actual = {option} toogleOption={setOption}/>
      <Body id="wrapper-body">
        <SidebarEvents toggleOption= {toogleOptionSidebar} toggleCollapsed={setCollapsed}/>
        <ContentContainer
          id={"content_container"}
          children =  {React.cloneElement(content, { collapsed: collapsed })}
        />
      </Body>
    </Wrapper>
      
  ); 
}

export default Dashboard;
